import React from 'react';
import MentorRegisterComponent from '../../../components/admin/coffee-chat/MentorRegisterComponent';

const MentorRegister: React.FC = () => {
  return <MentorRegisterComponent />;
};

export default MentorRegister;
